import { useQuery } from "@tanstack/react-query";
import { CampaignStatus, CampaignsService } from "@/services/campaigns.service";
import { adsHttpClient } from "@/utils/ads.http";
import { toCampaignRecord } from "@/utils/campaigns";

export type UseCampaignQueryParams = {
  statuses: CampaignStatus[];
};

export type CampaignRecord = {
  id: string;
  index: number;
  name: string;
  initials: string;
  active: boolean;
  market: string;
  placements: string[];
  placementCount: number;
  budget: string;
  budgetMilliDollars: number;
  spend: string;
  spendMilliDollars: number;
  impressions: number;
  impressionsLabel: string;
  ctr: number;
  ctrLabel: string;
  status: CampaignStatus;
  updatedAt: string;
  flightLabel: string;
  flightProgress: number | null;
};

const campaignsService = new CampaignsService(adsHttpClient);

async function fetchCampaigns(
  query: UseCampaignQueryParams,
): Promise<CampaignRecord[]> {
  const campaigns = await campaignsService.listSummaries(query);
  return campaigns.map(toCampaignRecord).map((campaign, index) => ({
    ...campaign,
    index: index + 1,
  }));
}

export function useCampaigns(
  query: UseCampaignQueryParams = {
    statuses: [],
  },
) {
  const statuses = [...query.statuses].sort();

  return useQuery({
    queryKey: ["campaigns", { statuses }],
    queryFn: () => fetchCampaigns({ statuses }),
    enabled: statuses.length > 0,
  });
}
